import { FaGraduationCap, FaLaptopCode, FaChalkboardTeacher } from "react-icons/fa";

const cards = [
  {
    icon: <FaGraduationCap size={26} className="text-cyan-400" />,
    title: "Education",
    body: (
      <>
        <p className="font-semibold text-white text-sm">B.S. in Computer Science</p>
        <p className="text-xs text-slate-500 mt-1">Northern Caribbean University, Jamaica &nbsp;·&nbsp; 2019 – 2023</p>
        <p className="text-sm text-slate-400 mt-3 leading-relaxed">
          Focused on software engineering, data structures, algorithms, database
          systems, and mobile application development.
        </p>
      </>
    ),
  },
  {
    icon: <FaLaptopCode size={26} className="text-cyan-400" />,
    title: "Who I Am",
    body: (
      <p className="text-sm text-slate-400 leading-relaxed">
        I'm a Software developer passionate about building practical,
        user-focused applications. I thrive across the full stack, from designing
        clean UIs to architecting REST APIs and relational database schemas.
        Passionate about problem-solving, continuous learning, and contributing
        within collaborative development environments.
      </p>
    ),
  },
  {
    icon: <FaChalkboardTeacher size={26} className="text-cyan-400" />,
    title: "Teaching & Mentoring",
    body: (
      <p className="text-sm text-slate-400 leading-relaxed">
        As an ICT Instructor at HEART/NSTA Trust, I deliver competency-based
        training aligned with national Level 2 and Level 3 standards applying
        TVET methodologies and differentiated instruction to prepare the next
        generation of tech professionals in Jamaica.
      </p>
    ),
  },
];

export default function AboutMe() {
  return (
    <section id="about" className="bg-navy-900 section-padding">
      <div className="container-max">
        <div className="text-center mb-14">
          <span className="section-tag">Get to Know Me</span>
          <h2 className="section-title mt-2">About Me</h2>
          <p className="section-sub">
            A little background on who I am, what I've studied, and what drives me as a developer.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div key={c.title} className="card-glow border-t-2 border-t-cyan-500/40">
              <div className="w-12 h-12 bg-cyan-500/10 rounded-xl flex items-center justify-center mb-5">
                {c.icon}
              </div>
              <h3 className="font-bold text-white text-base mb-3">{c.title}</h3>
              {c.body}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}